import { createStore, applyMiddleware } from 'redux';
import createSagaMiddleware from 'redux-saga';
import { composeWithDevTools } from 'redux-devtools-extension';
import reducers from './reducers';
import sagas from './sagas';

// 中间件
let sagaMiddleware = createSagaMiddleware();
let middleware = applyMiddleware(
    sagaMiddleware
);

// DevTools
middleware = process.env.NODE_ENV === 'development' ? composeWithDevTools(middleware) : middleware;

// store
export default createStore(
    reducers,
    middleware
);

// run sagas
sagaMiddleware.run(sagas);
